import { render, staticRenderFns } from "./PayrollPolicyAssignUserDetailsView.vue?vue&type=template&id=650f659d&"
import script from "./PayrollPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
export * from "./PayrollPolicyAssignUserDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./PayrollPolicyAssignUserDetailsView.vue?vue&type=style&index=0&id=650f659d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports